import React from 'react';
import { Link } from 'react-router-dom';
import LegalLayout, { Clause, Fact, Email } from './LegalLayout';
import { LEGAL } from './legalDetails';

export default function DataDeletion() {
  return (
    <LegalLayout title="How to Delete Your Data">

      <p>
        If you've sent a message to an organisation through Pulso, by WhatsApp, SMS, email or web form, you can
        ask us to delete the information we hold about you. Here's how.
      </p>

      <Clause n={1}>Email us</Clause>
      <p>
        Send an email to <Email value={LEGAL.contactEmail} /> with the subject line <strong>"Data deletion request"</strong>.
      </p>

      <Clause n={2}>Tell us what to look for</Clause>
      <p>Please include:</p>
      <ul>
        <li>
          <strong>The phone number or email address you used</strong> to send your messages. For WhatsApp or SMS,
          give the full number with the country code, for example +27 82 000 0000.
        </li>
        <li>The name of the organisation you contacted, if you know it.</li>
        <li>Roughly when you sent your messages, if you remember. This helps us find them faster.</li>
      </ul>
      <p>
        If you reported anonymously through a web form, we can't link messages to you by contact details. Tell us
        the organisation, the date and anything you remember about the message, and we'll do our best to find it.
      </p>

      <Clause n={3}>What happens next</Clause>
      <ol>
        <li>We'll reply to confirm we've received your request.</li>
        <li>We may ask you to confirm you own the phone number or email address, so nobody can delete someone else's information.</li>
        <li>We'll let the organisation you contacted know, because we handle your messages on their behalf.</li>
        <li>We'll delete your phone number or email address, your name, your messages, their translations, and any attachments or voice notes from Pulso.</li>
        <li>Note that we may keep the data around your messages – the themes identified and the sentiment – for aggregated reporting for our client. Nothing in this will identify you in any way.</li>
        <li>We'll email you to confirm once it's done.</li>
      </ol>

      <Clause n={4}>How long it takes</Clause>
      <p>
        We aim to complete deletion requests within <Fact value={LEGAL.deletionTimeframe} /> of confirming your
        identity. Copies in our backups are cleared automatically within <Fact value={LEGAL.backupRetentionPeriod} />.
      </p>

      <Clause id="things-to-know">Things to know</Clause>
      <ul>
        <li>
          Sometimes the law requires information to be kept, for example when a report is part of a legal or
          safety investigation. If we can't delete something, we'll tell you why.
        </li>
        <li>
          Deleting your data from Pulso doesn't delete it from WhatsApp, your phone, or your email account. Those
          are controlled by you and by those services.
        </li>
        <li>
          The organisation you contacted may already have acted on your message, for example by recording an
          incident in their own systems. You can ask them directly about information they hold outside Pulso.
        </li>
      </ul>

      <p>
        For more about how we handle your information and your other rights, read our{' '}
        <Link to="/privacy">Privacy Policy</Link>.
      </p>

    </LegalLayout>
  );
}
